module.exports = __webpack_public_path__ + "static/media/img_top_main1@2x.2fee07af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_top_main1@2x.jpg
// module id = 768
// module chunks = 0